<h2 mat-dialog-title>Atenção</h2>
<mat-dialog-content>
  <p class="mismatch-message">
    O valor informado (R$ {{ data.valueInformed | number:'1.2-2' }}) difere do valor provisionado
    (R$ {{ data.valueProvisioned | number:'1.2-2' }}). Como deseja prosseguir?
  </p>
</mat-dialog-content>

<mat-dialog-actions class="stacked-actions">
  @if(isDiscount) {
  <button mat-button (click)="onOptionClick(options.DISCOUNT)">
    Aplicar desconto ({{ diference | currency : 'BRL' }})
  </button>
  } @else {
  <button mat-button (click)="onOptionClick(options.SURCHARGE)">
    Aplicar juros/acréscimo ({{ diference | currency : 'BRL' }})
  </button>
  }
  <button mat-button (click)="onOptionClick(options.PARTIAL)">
    Manter saldo em aberto
  </button>
  <button mat-button (click)="onOptionClick(options.FINALIZE)" cdkFocusInitial>
    Alterar valor do título e zerar o saldo
  </button>
  <button class="danger" mat-button (click)="onCancel()">Cancelar</button>
</mat-dialog-actions>